/* ==========================================================
   Ziwara — Real Recently Viewed (sessionStorage — clears on browser close)
   Works on every page. Stores last 8 viewed product handles.
   Renders a live grid on homepage + product pages.
   ========================================================== */

(function () {
  var KEY   = 'ziwara_rv';
  var MAX   = 8;
  var SLOT  = 'recentlyViewedGrid';

  /* ── 1. Record current product page ── */
  var meta = document.querySelector('meta[name="ziwara-product-handle"]');
  if (meta) {
    var handle = meta.content;
    if (handle) {
      var list = getList();
      list = list.filter(function (h) { return h !== handle; });
      list.unshift(handle);
      if (list.length > MAX) list = list.slice(0, MAX);
      sessionStorage.setItem(KEY, JSON.stringify(list));
      /* Mark that this SESSION has actually browsed products */
      sessionStorage.setItem('ziwara_rv_active', '1');
    }
  }

  /* ── 2. Render the grid — PRODUCT PAGES ONLY ── */
  document.addEventListener('DOMContentLoaded', function () {
    var grids = document.querySelectorAll('[id="' + SLOT + '"]');
    if (!grids.length) return;

    /* Render wherever the grid div exists (only in main-product.liquid) */

    var list = getList();
    var currentHandle = meta ? meta.content : null;
    if (currentHandle) list = list.filter(function (h) { return h !== currentHandle; });

    if (list.length === 0) {
      grids.forEach(function (grid) {
        grid.closest('.rv-section') && (grid.closest('.rv-section').style.display = 'none');
      });
      return;
    }

    /* Fetch each product's JSON from the Shopify storefront */
    var fetched = 0;
    var products = [];

    list.forEach(function (handle, i) {
      fetch('/products/' + handle + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (product) {
          if (product) products[i] = product;
          fetched++;
          if (fetched === list.length) renderAll(products.filter(Boolean).slice(0, 4));
        })
        .catch(function () {
          fetched++;
          if (fetched === list.length) renderAll(products.filter(Boolean).slice(0, 4));
        });
    });
  });

  function getList() {
    try { return JSON.parse(sessionStorage.getItem(KEY) || '[]'); } catch (e) { return []; }
  }

  function money(cents) {
    if (window.Shopify && Shopify.formatMoney) return Shopify.formatMoney(cents, window.ziwaraMoneyFormat);
    return '₹' + (cents / 100).toLocaleString('en-IN');
  }

  function badge(product) {
    var tags = product.tags || [];
    if (tags.indexOf('House Icon') > -1) return '<span class="badge">House Icon</span>';
    if (tags.indexOf('Bestseller') > -1) return '<span class="badge">Bestseller</span>';
    if (tags.indexOf('Hot') > -1) return '<span class="badge">Hot</span>';
    if (tags.indexOf('New') > -1) return '<span class="badge gold">New</span>';
    if (product.compare_at_price > product.price) {
      var pct = Math.round((1 - product.price / product.compare_at_price) * 100);
      return '<span class="badge gold">' + pct + '% off</span>';
    }
    return '';
  }

  /* Render into every grid on the page */
  function renderAll(products) {
    var grids = document.querySelectorAll('[id="' + SLOT + '"]');
    grids.forEach(function (grid) { render(grid, products); });
  }

  function render(grid, products) {
    if (!grid) return;
    if (products.length === 0) {
      grid.closest('.rv-section') && (grid.closest('.rv-section').style.display = 'none');
      return;
    }

    grid.innerHTML = products.map(function (p) {
      var img    = p.featured_image ? (p.featured_image + '&width=900') : '';
      var alt2   = p.images && p.images[1] ? (p.images[1].src + '&width=900') : '';
      var price  = money(p.price);
      var mrp    = p.compare_at_price > p.price ? money(p.compare_at_price) : '';
      var pct    = p.compare_at_price > p.price ? Math.round((1 - p.price / p.compare_at_price) * 100) : 0;
      var avail  = p.available;
      var vid    = p.variants && p.variants[0] ? p.variants[0].id : '';
      var bdg    = badge(p);

      return '<article class="card" data-testid="rv-card-' + p.handle + '">' +
        '<a href="/products/' + p.handle + '" aria-label="' + escHtml(p.title) + '">' +
          '<div class="card-media">' +
            (img ? '<img class="main" loading="lazy" src="' + img + '" alt="' + escHtml(p.title) + '">' : '') +
            (alt2 ? '<img class="alt" loading="lazy" src="' + alt2 + '" alt="' + escHtml(p.title) + ' alternate">' : '') +
            bdg +
            '<span class="fav" aria-hidden="true"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M12 21s-7-4.5-9.3-9.2C1 8.5 3 5 6.5 5c2 0 3.4 1 5.5 3 2.1-2 3.5-3 5.5-3C21 5 23 8.5 21.3 11.8 19 16.5 12 21 12 21Z"/></svg></span>' +
            '<div class="quick">' +
              (avail
                ? '<button type="button" class="btn" data-quick-add data-variant-id="' + vid + '" data-product-title="' + escHtml(p.title) + '" data-testid="rv-add-' + p.handle + '">Add to Bag</button>'
                : '<span class="btn" style="opacity:.65;cursor:default">Sold Out</span>') +
            '</div>' +
          '</div>' +
          '<div class="card-body">' +
            '<span class="card-cat">' + escHtml(p.type || p.vendor || '') + '</span>' +
            '<h3 class="card-title">' + escHtml(p.title) + '</h3>' +
            '<div class="card-price">' +
              '<b>' + price + '</b>' +
              (mrp ? '<s>' + mrp + '</s><em>' + pct + '% off</em>' : '') +
            '</div>' +
            //'<div class="card-rate"><span>Free Shipping</span></div>' +
          '</div>' +
        '</a>' +
      '</article>';
    }).join('');

    /* Reveal the section now that cards are rendered */
    var section = grid.closest('.rv-section');
    if (section) section.classList.add('rv-ready');

    /* Wire quick-add buttons in the newly rendered grid */
    grid.querySelectorAll('[data-quick-add]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        var vid  = btn.getAttribute('data-variant-id');
        var name = btn.getAttribute('data-product-title');
        if (vid && window.addItemToCart) window.addItemToCart(vid, 1, name);
      });
    });
  }

  function escHtml(str) {
    return String(str || '').replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
  }
})();